import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Language } from '@libraries/design-system';
import { FeaturesService } from '@libraries/feature-flags';
import { Store } from '@ngrx/store';
import { SetFromUrl, SwitchPreferredLanguage } from '../state';

@Injectable()
export class CheckQuestionUrlPrefilledGuard implements CanActivate {
  excludedParams = ['max_fund', 'rem_fund'];

  constructor(private store: Store, private features: FeaturesService) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const params = route.queryParams;
    const paramKeys = Object.keys(params);

    // We get query params for eligible funds too. When we load eligible funds, prequal is getting loaded and dispatching the SetFromUrl action. Which is causing issues. To avoid that we are checking some params which are only present for Eligible Funds and if those keys are present, we are avoiding the dispatch.
    // Catch Kranthi/Brandon if you aren't clear, as those are the culprits who did this fix :P
    const skipDispatch = paramKeys.some((key) => this.excludedParams.includes(key));

    if (this.features.isOff('yt-19374-pace-pause-prequal-updates') && params.language) {
      let preferredLanguage: Language;
      if (params.language === Language.Espanol) {
        preferredLanguage = Language.Espanol;
      } else {
        preferredLanguage = Language.English;
      }

      this.store.dispatch(SwitchPreferredLanguage({ preferredLanguage }));
    }

    if (paramKeys.length > 0 && !skipDispatch) {
      this.store.dispatch(SetFromUrl({ payload: params }));
    }
    return true;
  }
}
